import React, { useEffect, useState, useContext } from "react";

import Api from "../service/api";

import RegistryViews from "../components/registry_components/registry_views";

import UserContext from "../context/user_context";
import { ErrorLog, Log } from "../helpers/logs";

/*
    Registry Component


    Parent view for all of the registry component logic

    Author: William Brown
    Updated By: 
*/
export default function Registries(props) {
  // Variables used to denote wheter the table is being used for high criticality or not
  const { highCriticality } = props;

  var currentUser = useContext(UserContext);
  const { user_preference } = currentUser;

  const [activeRow, setActiveRow] = useState(-1);
  const [activeTab, setActiveTab] = useState("init");
  const [registries, setRegistries] = useState([]);
  const [registry, setRegistry] = useState({});
  const [columns, setColumns] = useState([]);
  const [patientData, setPatientData] = useState([]);

  //#region Registry Drop down components section

  const [locations, setLocations] = useState([]);
  const [location, setLocation] = useState({});

  const [physicians, setPhysicians] = useState([]);
  const [physician, setPhysician] = useState(null);

  //#endregion

  const [clients, setClients] = useState();
  const [loading, setLoading] = useState(false);

  // Pagination Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState("stratification.rank");
  const [order, setOrder] = useState("desc");
  const [filterText, setFilterText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const [pageProps, setPageProps] = useState([]);

  const [textLoading, setTextLoading] = useState(null);
  const [timer, setTimer] = useState(null);
  const [time, setTime] = useState(2000);
  const [customSort, setCustomSort] = useState(null);

  var defCartValue = [];

  if (localStorage.getItem("_cart") != undefined) {
    defCartValue = localStorage.getItem("_cart");
  }
  const [cart, setCart] = useState(defCartValue);

  useEffect(() => {
    if (activeTab == "init") {
      return;
    }

    getPatientsByRegistry(registry.id);
  }, [page, order]);

  useEffect(() => {
    if (activeTab == "init") {
      return;
    }

    getPatientsByRegistry(registry.id, true);
  }, [rowsPerPage]);

  useEffect(() => {
    getLocations();
  }, []);

  useEffect(() => {
    if (locations.length > 0 && location.id != undefined) {
      getRegistries();
    }
  }, [locations, location]);

  useEffect(() => {
    if (registries.length > 0) {
      getPhysicians(location, registries);
    }
  }, [registries]);

  useEffect(() => {
    if (currentUser != null && currentUser.id != undefined) {
      getClientsByUser();
    }
  }, [currentUser]);

  useEffect(() => {
    if (activeTab == "init") {
      return;
    }
    if (
      registries[registries.findIndex((x) => x.code == activeTab)] === undefined
    ) {
      return;
    }

    setActiveRow(-1);

    setColumns(
      () =>
        registries[registries.findIndex((x) => x.code == activeTab)]
          .registry_columns,
    );
    setRegistry(
      () => registries[registries.findIndex((x) => x.code == activeTab)],
    );

    getPatientsByRegistry(
      registries[registries.findIndex((x) => x.code == activeTab)].id,
      true,
    );
  }, [activeTab, physician]);

  // useEffect(() => {
  //   getPhysicians();
  // }, [location]);

  useEffect(() => {
    if (textLoading == true) {
      if (timer != null) {
        setTimer(() => clearTimeout(timer));

        setTimer(() =>
          setTimeout(() => getPatientsByRegistry(registry.id, true), time),
        );
      } else {
        setTimer(() => clearTimeout(timer));

        setTimer(() =>
          setTimeout(() => getPatientsByRegistry(registry.id, true), time),
        );
      }
    }
  }, [filterText]);

  function filterTextWrapper(e) {
    setTextLoading(() => true);
    setFilterText(() => e);
  }

  function getClientsByUser() {
    Api.IConnectApi.CurrentUserClients()
      .then((response) => {
        var cli = response.clients;

        cli.map((cl) => {
          cl.label = cl.code;
          cl.value = cl.code;

          return;
        });

        setClients(cli);
      })
      .catch((er) => {
        ErrorLog(`Er: `, er);
      });
  }

  function getRegistries() {
    Api.IConnectApi.GetAllRegistries(location.id)
      .then((response) => {
        var reg = response.registries;
        reg.map((re) => {
          re.label = re.name;
          re.value = re.code;
        });

        setRegistries(reg);
      })
      .catch((er) => {
        Log("Er: ", er);
      });

    return;
  }

  function getPatientsByRegistry(code, resetPage) {
    if (resetPage != undefined) {
      var tempPage = Object.assign(page);

      setPage(0);

      if (tempPage != 0) {
        return;
      }
    }

    var body = {};

    if (highCriticality != undefined && highCriticality) {
      body.critical = true;
    }

    if (location.id == undefined) return null;

    body.client_location_id = location.id;

    if (physician.value != null) {
      body.physician_id = physician.id;
    }

    body.include_order_tests = true;

    body.pagination = true;
    body.sort_header = orderBy;
    body.sort_order = order;
    body.page_number = page + 1;
    body.page_size = rowsPerPage;
    body.filter_text = filterText;

    if (customSort != null) {
      body.sort_type = customSort;
    }

    setLoading(() => true);
    setTextLoading(() => false);
    setTimer(() => clearTimeout(timer));

    Api.IConnectApi.getRegestryPatients(code, body)
      .then((response) => {
        setPatientData(() => response.data);
        if (!body.pagination) {
          setTotalRecords(() => response.data.length);
        }
        {
          setTotalRecords(() => response.total_records);
        }

        setLoading(() => false);
      })
      .catch((er) => {
        setLoading(() => false);

        Log("Er: ", er);
      });

    return;
  }

  function getLocations() {
    Api.IConnectApi.getLocations()
      .then((response) => {
        var locations_response = response.client_locations;

        locations_response.map((lr) => {
          lr.label = lr.name;
          lr.value = lr.id;
        });

        setLocations(locations_response);

        var locationIndex =
          user_preference.preferred_client_id != null
            ? user_preference.preferred_client_id
            : 0;

        if (
          locationIndex == 0 ||
          locations_response.findIndex((x) => x.id == locationIndex) == -1
        ) {
          setLocation(locations_response[0]);
        } else if (
          locations_response.findIndex((x) => x.id == locationIndex) != -1
        ) {
          setLocation(
            locations_response[
              locations_response.findIndex((x) => x.id == locationIndex)
            ],
          );
        } else {
          setLocation(locations_response[0]);
        }
      })
      .catch((er) => {
        Log("Er: ", er);
      });
  }

  function getPhysicians(loc, registriesTemp) {
    var dataToSend = location;

    if (loc != undefined) {
      dataToSend = loc;
    }

    if (dataToSend.id == undefined) {
      return null;
    }

    Api.IConnectApi.getPhysicians(dataToSend.id)
      .then((response) => {
        var physicians_response = response.physicians;

        physicians_response.map((pr) => {
          pr.label = pr.display_name;
          pr.value = pr.id;
        });

        physicians_response.unshift({ label: "Any Provider", value: null });

        setPhysicians(physicians_response);

        if (
          user_preference.preferred_client_id === dataToSend.id &&
          user_preference.preferred_physician_id != null
        ) {
          var tempPhysician = physicians_response.find(
            (x) =>
              x.id ==
              (physician === null
                ? user_preference.preferred_physician_id
                : physician.id),
          );

          if (tempPhysician == undefined || tempPhysician.value == null) {
            setPhysician({ label: "Any Provider", value: null });
          } else {
            tempPhysician.value = tempPhysician.id;
            tempPhysician.label = tempPhysician.display_name;

            setPhysician(tempPhysician);
          }
        } else {
          setPhysician({ label: "Any Provider", value: null });
        }

        if (
          user_preference.preferred_registry_id != null &&
          activeTab == "init"
        ) {
          var tempReg = registriesTemp.find(
            (x) => x.id == user_preference.preferred_registry_id,
          );

          if (tempReg == undefined) {
            setActiveTab(registriesTemp[0].code);
          } else {
            setActiveTab(tempReg.code);
          }
        } else {
          setActiveTab(registriesTemp[0].code);
        }
      })
      .catch((er) => {
        Log("Er: ", er);
      });
  }

  const registryProps = {
    activeRow: activeRow,
    registries: registries,
    patientData: patientData,
    columns: columns,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    clients: clients,
    setClients: setClients,
    cart: cart,
    setCart: setCart,
    loading: textLoading || loading,
    registry: registry,
    locations: locations,
    location,
    setLocation,
    physicians,
    physician,
    setPhysician,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    orderBy,
    setOrderBy,
    order,
    setOrder,
    filterText,
    setFilterText: filterTextWrapper,
    totalRecords,
    setTotalRecords,
    getPatientsByRegistry,
    setCustomSort,
  };

  return (
    <>
      <RegistryViews {...registryProps} {...props} />
    </>
  );
}
